export enum CodeEditorLanguage {
  Json = 'json',
  Yaml = 'yaml',
  Text = 'text',
  Toml = 'toml',
}
